export default {
  INPUT: {
    TEXT: 'text',
    TEXT_LONG: 'text_long',
    NUMBER: 'number',
    URL: 'url',
    EMAIL: 'email',
    DATE: 'date',
    LOCATION: 'location',
    FILE: 'file',
    TEL: 'tel',
    DIALOG: 'dialog',
    BUTTONS: 'buttons',
    BUTTONS_MULTIPLE: 'buttons_multiple',
    BUTTONS_SEARCH: 'buttons_search',
    BUTTONS_MULTI_SEARCH: 'buttons_multi_search',
    AUTOCOMPLETE: 'autocomplete',
    SCALE: 'scale',
    RATING: 'rating',
    YES_NO: 'yes_no',
    CARDS: 'cards',
    REFERRAL: 'referral',
    STRIPE: 'stripe',
    MESSAGEWITHINPUT: 'messagewithinput',
    FORM: 'form',
  },
};
